<script>
  export let review;
  export let order;
  function getDate2(datetime) {
    let d = new Date(datetime);
    return d.getFullYear() + "." + (d.getMonth() + 1) + "." + d.getDate();
  }
  function removeTrialString(str) {
    return str.replace("[시착제품]", "");
  }

  /* console.log('updated_at: ', review.updated_at); */
  /* console.log('created_at: ', review.created_at); */
  /* console.log('order: ', order); */
</script>

<div class="_w-allrev-list review">
  {#if review.old_image || review.image_file_name}
    <div class="_w-allrev-photo">
      <a href={review.product_page_url}>
        <img
          src={review.old_image
            ? review.old_image
            : `https://objectstorage.ap-seoul-1.oraclecloud.com/n/cnk6gaix2gpw/b/genuio-uploads/o/review-imgs/w_600/${review.image_file_name}`}
          loading="lazy"
          sizes="(max-width: 479px) 92vw, (max-width: 991px) 48vw, 27vw"
          srcset=""
          alt=""
          class="image-7"
        />
      </a>
    </div>
  {/if}
  <div class="_w-allrev-user">
    <a href={review.product_page_url} class="_w-allrev-prd-name w-inline-block">
      <div>{removeTrialString(review.product_title)}</div>
    </a>
    <div class="_w-allrev-star-section">
      <div class="_w-allrev-score">
        {#each Array(review.product_rating) as _, index}
          <img
            src="https://uploads-ssl.webflow.com/60da6c51187bb4956c0ac962/60dbc0e3cd25648ef768af8d_star-black.svg"
            loading="lazy"
            alt=""
            class="_w-allrev-star-svg"
          />
        {/each}
      </div>
      <div class="_w-allrev-write-date">
        <div>{getDate2(review.created_at)}</div>
      </div>
    </div>
    <div class="_w-allrev-user-id">
      <div>{review.user_nickname}</div>
    </div>
    <div class="_w-allrev-textfield">
      <div>{review.comment_content}</div>
    </div>
  </div>
</div>

<style>
  ._w-allrev-score {
    display: flex;
    align-items: center;
  }
</style>
